import React from "react"
import { Helmet } from "react-helmet"

import useSchema from "./useSchema"

const Schema = ({ article, recipeSchema }) => {
  const schema = useSchema(article)

  return (
    <Helmet>
      {schema && Object.keys(schema).length > 0 && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
      {recipeSchema && Object.keys(recipeSchema).length > 0 && (
        <script type="application/ld+json">{JSON.stringify(recipeSchema)}</script>
      )}
    </Helmet>
  )
}

export default React.memo(Schema)
